module.exports = __webpack_public_path__ + "static/template_options_month_rows-8bc5487fae35e49cf503cfa29cf36bc9.png";